export default "__VITE_ASSET__22456266__"